import { Component, Input, OnInit } from '@angular/core';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';
import { IApiAddSyncSageContactInput, IApiInvestigation, IApiSageContact } from 'src/app/shared/modules/graphql/types/types';
import { LoaderService } from 'src/app/shared/modules/loader/loader.service';
import { NotificationsService } from 'src/app/shared/modules/notifications/notifications.service';
import { ContactService } from 'src/app/shared/services';

@Component({
  selector: 'app-sage-contact-selection-modal',
  templateUrl: './sage-contact-selection-modal.component.html',
  styleUrls: ['./sage-contact-selection-modal.component.scss']
})
export class SageContactSelectionModalComponent extends DialogContentBase implements OnInit {
  @Input() investigation: IApiInvestigation;
  public sageContacts: IApiSageContact[] = [];
  public selectedSageId = '';

  constructor(
    public dialogRef: DialogRef,
    private contactService: ContactService,
    private loader: LoaderService,
    private notification: NotificationsService
  ) {
    super(dialogRef);
  }

  ngOnInit(): void {
    this.loader.show$(this.contactService.getSageContactsByName(this.investigation.BillTo?.id).pipe(this.notification.snackbarErrorPipe())).subscribe(response => {
      this.sageContacts = response;
    })
  }

  public close(result = false) {
    this.dialogRef.close(result);
  }

  public submit() {
    const input: IApiAddSyncSageContactInput = {
      BillToId: this.investigation?.BillTo?.id,
      InvestigationId: this.investigation?.id,
      SageId: this.selectedSageId,
      SageKey: this.sageContacts?.find(s => s.id === this.selectedSageId)?.key || '',
      createNew: this.selectedSageId === 'NEW',
    };

    this.loader.show$(this.contactService.addSyncSageContact(input).pipe(this.notification.snackbarPipe('Sage contact synced successfully'), this.notification.snackbarErrorPipe())).subscribe((response) => {
      if (response?.id) {
        this.close(response);
      }
    })

  }
}
